export default __webpack_public_path__ + "static/media/Beehaz_10_features.a81c84e9.png";